import React, { FC } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Leads } from './Leads';
import { LeadDetails } from './LeadDetails';


export const LeadsRouter: FC = (props) => {

  const { path } = useRouteMatch();

  return (<Switch>
    <Route exact path={path}>
      <Leads />
    </Route>
    <Route exact path={`${path}/:id`}>
      <LeadDetails />
    </Route>
  </Switch>);
};
